import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getGachaId = async (idGacha) => {
  try {
    const res = await axiosInstance.get(API_ROUTES.GachasId.replace(':id', idGacha))
    return res.data
  } catch (error) {
    console.error('Error fetching gacha data:', error)
    throw error
  }
}

export default getGachaId
